class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.handleEscape = (evt) => {
      if (evt.code === 'Escape') this.close();
    };

    this.handleOverlayClick = this.close.bind(this);

    this.addEventListener('keyup', this.handleEscape);

    this.overlay = this.querySelector('#CartDrawer-Overlay');
    if (this.overlay) {
      this.overlay.addEventListener('click', this.handleOverlayClick);
    }

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.setAttribute('aria-expanded', this.classList.contains('active') ? 'true' : 'false');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      const code = event.code.toUpperCase();
      if (code === 'SPACE' || code === 'ENTER') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    requestAnimationFrame(() => {
      this.classList.add('animate', 'active');
      this.updateCartTriggerState(true);
    });

    const trapTarget = this.classList.contains('is-empty')
      ? this.querySelector('.drawer__inner-empty')
      : document.getElementById('CartDrawer');

    const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close') || this;

    const handleTransitionEnd = () => {
      if (trapTarget) {
        trapFocus(trapTarget, focusElement);
      }
    };

    this.addEventListener('transitionend', handleTransitionEnd, { once: true });

    setTimeout(() => {
      if (this.classList.contains('active') && trapTarget) {
        trapFocus(trapTarget, focusElement);
      }
    }, 350);

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    this.updateCartTriggerState(false);
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  updateCartTriggerState(isOpen) {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (cartLink) {
      cartLink.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling?.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement?.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner?.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      if (!parsedState.sections || !parsedState.sections[section.id]) return;

      const innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if (innerHTML !== null) {
        sectionElement.innerHTML = innerHTML;
      }
    });

    this.overlay = this.querySelector('#CartDrawer-Overlay');
    if (this.overlay) {
      this.overlay.removeEventListener('click', this.handleOverlayClick);
      this.overlay.addEventListener('click', this.handleOverlayClick);
    }

    this.setHeaderCartIconAccessibility();

    setTimeout(() => {
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element ? element.innerHTML : null;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartDrawerItems);
}